// axiosInstance.js
import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: 'https://mittal-back-olb5.onrender.com/'
});

export default axiosInstance;

export const weburl = 'https://mittal-back-olb5.onrender.com/';
export const shopurl = 'https://ms.delhiexpert.com/';
export const mainurl = 'https://ms.delhiexpert.com/';
